export enum AODocsRole {
  NONE ="NONE",
  READER ="READER",
  COMMENTER ="COMMENTER",
  WRITER="WRITER",
  ADMIN="ADMIN",
  SUPER_ADMIN="SUPER_ADMIN",
}
